export default __webpack_public_path__ + "static/media/User2.89ab046f.jpg";